import { isValidLatitude, isValidLongitude } from '@gorila-shared-ui/components';
import { FixedMarker, FixedMarkerOverrides } from 'baseui/map-marker';
import { memo, useEffect } from 'react';
import { Marker } from 'react-map-gl/mapbox';
import { useRecoilValue } from 'recoil';
import { useCamera } from '../../../hooks/useCamera';
import { mapViewState } from '../../../storage/map';
import { activeTelemetryState, reportTelemetryLngLatsState, reportTelemetryState } from '../../../storage/reports';

function TelemetryMarkers() {
  const assetId = useRecoilValue(activeTelemetryState);
  const states = useRecoilValue(reportTelemetryState(assetId || ''));
  const lngLats = useRecoilValue(reportTelemetryLngLatsState(assetId || ''));
  const { fitToLngLats } = useCamera();
  const { zoom } = useRecoilValue(mapViewState);

  const fixedMarkerOverrides: FixedMarkerOverrides = {
    Root: {
      style: () => ({
        transform: `translateY(-50%)`,
      }),
    },
  };

  useEffect(() => {
    if (!lngLats.length) return;

    fitToLngLats(lngLats);
  }, [lngLats, assetId, fitToLngLats]);

  if (!states?.length || !assetId) return null;

  const hidePositions = zoom < 15;

  return (
    <>
      {states.map((state, index) => {
        const isFirst = index === 0;
        const isLast = index === states.length - 1;
        const isBetween = !isFirst && !isLast;

        const longitude = state.position_longitude;
        const latitude = state.position_latitude;

        if (!latitude || !longitude) return null;

        if (!isValidLatitude(latitude) || !isValidLongitude(longitude)) return null;

        if (isBetween && hidePositions) return null;

        return (
          <Marker
            longitude={longitude}
            latitude={latitude}
            key={index}
          >
            {isFirst && (
              <FixedMarker
                label="Inicio"
                size="small"
                overrides={fixedMarkerOverrides}
              />
            )}
            {isBetween && (
              <FixedMarker
                size={'xx-small-circle'}
                needle="none"
              />
            )}
            {isLast && !isFirst && (
              <FixedMarker
                label="Fin"
                size="small"
                overrides={fixedMarkerOverrides}
              />
            )}
          </Marker>
        );
      })}
    </>
  );
}

export default memo(TelemetryMarkers);
